import { render, staticRenderFns } from "./PathBar.vue?vue&type=template&id=52ef9e0f&scoped=true&"
import script from "./PathBar.vue?vue&type=script&lang=js&"
export * from "./PathBar.vue?vue&type=script&lang=js&"
import style0 from "./PathBar.vue?vue&type=style&index=0&id=52ef9e0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ef9e0f",
  null
  
)

export default component.exports